import {MoreHorizontal} from 'lucide-react'
import {Slot} from 'radix-ui'
import * as React from 'react'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'

function Breadcrumb({...props}: React.ComponentProps<'nav'>) {
  return <nav aria-label='breadcrumb' data-slot='breadcrumb' {...props} />
}

function BreadcrumbList({className, ...props}: React.ComponentProps<'ol'>) {
  return (
    <ol
      data-slot='breadcrumb-list'
      className={cn('text-muted-foreground flex flex-wrap items-center gap-3 text-sm wrap-break-word sm:gap-2.5', className)}
      {...props}
    />
  )
}

function BreadcrumbItem({className, ...props}: React.ComponentProps<'li'>) {
  return <li data-slot='breadcrumb-item' className={cn('inline-flex items-center gap-1.5', className)} {...props} />
}

function BreadcrumbLink({
  asChild,
  className,
  ...props
}: React.ComponentProps<'a'> & {
  asChild?: boolean
}) {
  const Comp = asChild ? Slot.Root : 'a'

  return <Comp data-slot='breadcrumb-link' className={cn('hover:text-foreground text-[12px] font-semibold transition-colors', className)} {...props} />
}

function BreadcrumbPage({className, ...props}: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot='breadcrumb-page'
      role='link'
      aria-disabled='true'
      aria-current='page'
      className={cn('text-foreground text-[14px] font-bold', className)}
      {...props}
    />
  )
}

function BreadcrumbSeparator({children, className, ...props}: React.ComponentProps<'li'>) {
  return (
    <li data-slot='breadcrumb-separator' role='presentation' aria-hidden='true' className={cn('text-xl', className)} {...props}>
      {children ?? '/'}
    </li>
  )
}

function BreadcrumbEllipsis({className, ...props}: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot='breadcrumb-ellipsis'
      role='presentation'
      aria-hidden='true'
      className={cn('flex size-9 items-center justify-center', className)}
      {...props}>
      <MoreHorizontal className='size-4' />
      <span className='sr-only'>More</span>
    </span>
  )
}

export {Breadcrumb, BreadcrumbEllipsis, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator}
